<template>
  <div class="px-2">
    <div class="d-flex align-center py-2">
      <span class="ml-1 font-19 font-weight-medium">Análise curvas cruzadas</span>

      <div class="ml-3 cursor-pointer" @click="tipo_visao = (tipo_visao === 'F') ? 'Q' : 'F'">
        <v-icon size="20">mdi-swap-horizontal</v-icon>
        <span class="font-12 ml-1">{{ (tipo_visao === 'F') ? 'Visão financeira' : 'Visão quantitativa' }}</span>
      </div>

      <v-divider vertical class="mx-3" />

      <v-spacer />

      <FiltrosUniversalAvancado />

      <template v-if="ativar_parametrizacao_diagnostico">
        <ParametrizacaoDeCoberturas  class="ml-3" @coberturas-alteradas="coberturas_mudou_count++" />

        <AplicarCoberturas class="ml-3" :coberturas_mudou_count="coberturas_mudou_count" />
      </template>

      <IndicadorEvolucao class="ml-3" />

      <ExportacaoParaExcel />
    </div>

    <Tabela
      :tipo_visao="tipo_visao"
      :coberturas_mudou_count="coberturas_mudou_count"
      @duplo-click:linha="linha => (linha_selecionada = linha)"
    />

    <DetalhamentoLinhaClicada :linha="linha_selecionada" />
  </div>
</template>

<script>
import Tabela from "@/components/Diagnostico/CurvasCruzadas/Tabela";
import ParametrizacaoDeCoberturas from "@/components/Diagnostico/CurvasCruzadas/ParametrizacaoDeCoberturas/Index";
import DetalhamentoLinhaClicada from "@/components/Diagnostico/LinhaDuplamenteClicada/Index";
import AplicarCoberturas from "@/components/Diagnostico/CurvasCruzadas/AplicarCoberturas";
import IndicadorEvolucao from "@/components/Diagnostico/CurvasCruzadas/IndicadorEvolucao/Index";
import ExportacaoParaExcel from "@/components/Diagnostico/ExportacaoParaExcel";
import * as req from "@/api/Diagnostico/CurvasCruzadas";
import { logout } from "@/helpers/index";
import FiltrosUniversalAvancado from "@/components/utils/FiltrosUniversalAvancado.vue";

export default {
  name: 'Diagnostico',
  components: {
    FiltrosUniversalAvancado,
    ExportacaoParaExcel,
    AplicarCoberturas,
    DetalhamentoLinhaClicada,
    ParametrizacaoDeCoberturas,
    Tabela,
    IndicadorEvolucao
  },
  data: () => ({
    linha_selecionada: null,
    coberturas_mudou_count: 0,
    tipo_visao: localStorage.diagnostico_tipo_visao || 'F',
    ativar_parametrizacao_diagnostico: false
  }),
  watch: {
    tipo_visao() {
      if (this.tipo_visao !== localStorage.diagnostico_tipo_visao) {
        localStorage.diagnostico_tipo_visao = this.tipo_visao;
      }
    }
  },
  mounted() {
    this.buscarPermissaoParametrizacaoDiagnostico();
  },
  methods: {
    buscarPermissaoParametrizacaoDiagnostico() {
      this.$store.dispatch(
        "loading/addRequisicao",
        req.buscarPermissaoParametrizacaoDiagnostico()
        .then(valor => this.ativar_parametrizacao_diagnostico = valor)
        .catch(logout)
      )
    },
  },
}
</script>

<style scoped>
</style>
